export default __webpack_public_path__ + "static/media/047-cone.b175f959.png";